import * as React from "react";
import {
  Modal,
  Fade,
  Card,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
} from "@mui/material";
import PropTypes from "prop-types";
// Kaizen Dashboard components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

//Context
import { useContext } from "react";
import { MessageManager } from "context";
import colors from "assets/theme/base/colors";
import SoftInput from "components/SoftInput";
import { useRef } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { urlBase } from "services/config";
import axios from "axios";
import { green } from "@mui/material/colors";
import { agregarCeros } from "utils/truncate";
import { useEffect } from "react";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80%", sm: "60%", md: "60%" },
  py: 4,
};

const user = localStorage.getItem("user");
const parsedUser = user ? JSON.parse(user) : null;

export default function ModalCambiarDestino({ open, handleClose, remito, refetch }) {
  const [listadoSucursales, setListadoSucursales] = useState([]);
  const [destino, setDestino] = useState("");
  const [loadingSave, setLoadingSave] = useState(false);
  const { handleSnackbar } = useContext(MessageManager);

  useEffect(() => {
    if (open) {
      const getUsuarios = async () => {
        try {
          const response = await axios.get(urlBase + "users");
          setListadoSucursales(response.data);
        } catch (error) {
          console.error(error);
        }
      };
      getUsuarios();
    }
    if (!open) {
    }
  }, [open]);

  const saveDestino = useCallback(async () => {
    setLoadingSave(true);
    try {
      await axios.put(urlBase + `remitoEncabezados/${remito.id}`, {
        destino: destino,
      });
      await axios.put(urlBase + `cambiar-destino`, {
        destino: destino,
        idEncabezado: remito.id,
        nombreSucursal: listadoSucursales.find((sucursal) => sucursal.codigo == destino).name,
      });
      handleSnackbar("El destino del remito se ha cambiado correctamente", "success");
      setDestino("");
      refetch();
      handleClose();
    } catch (error) {
      handleSnackbar("Ha ocurrido un error al cambiar el destino del remito", "error");
    } finally {
      setLoadingSave(false);
    }
  }, [destino, remito, handleClose]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={(event, reason) => {
        if (reason === "escapeKeyDown") {
          handleClose();
        }
      }}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox px={3}>
            <SoftBox display={"flex"} justifyContent="space-between" alignItems="end" pb={3}>
              <SoftTypography variant="h6">
                {`Cambiar sucursal de destino. Remito N° ${
                  agregarCeros(remito?.codigoSucursal, 4) + "-" + remito?.numero
                }`}{" "}
              </SoftTypography>

              <SoftButton
                variant="text"
                color="dark"
                size="large"
                onClick={() => {
                  handleClose();
                }}
              >
                Cerrar
                <Icon
                  sx={{
                    ml: 1.5,
                  }}
                >
                  close
                </Icon>
              </SoftButton>
            </SoftBox>
            <Grid container>
              <Grid item xs={12}>
                <InputLabel>
                  <SoftTypography variant="subtitle2" fontWeight="bold">
                    Destino
                  </SoftTypography>
                </InputLabel>
                <Select value={destino} onChange={(e) => setDestino(e.target.value)}>
                  {listadoSucursales
                    .filter((listado) => listado.codigo !== parsedUser.codigo)
                    .map((sucursal) => (
                      <MenuItem value={sucursal.codigo} key={sucursal.codigo}>
                        {sucursal.name}
                      </MenuItem>
                    ))}
                </Select>
              </Grid>
            </Grid>
            <SoftBox display="flex" justifyContent="flex-end" alignItems="center" pt={3}>
              <SoftBox>
                <SoftButton
                  variant="gradient"
                  color="dark"
                  size="large"
                  onClick={saveDestino}
                  disabled={loadingSave || !destino}
                >
                  {!loadingSave ? (
                    <>
                      <Icon
                        sx={{
                          mr: 0.4,
                        }}
                      >
                        save
                      </Icon>
                      {loadingSave ? (
                        <CircularProgress sx={{ margin: "0 15px" }} size={18} color="white" />
                      ) : (
                        "Guardar"
                      )}
                    </>
                  ) : (
                    <CircularProgress sx={{ margin: "0 15px" }} size={18} color="white" />
                  )}
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalCambiarDestino.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  remito: PropTypes.object,
  refetch: PropTypes.func,
};
